import './css/stylesheet.css';
import './fonts/fontsheet.css';
import React, { useState } from 'react';

function NavLink({ setWindows, name }){
    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = () => {
       setIsHover(true);
    };
    const handleMouseLeave = () => {
       setIsHover(false);
    };

    return (
        <p 
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} onClick={() => setWindows(name)} style={{
                fontFamily: "Charcoal",
                padding: "0 0.5%",
                margin: 0,
                fontSize: "1em",
                backgroundColor: isHover? "#EFEFEF": "#FFFFFF"
        }}>{name}</p>
    )
}

function Navigation({setWindows}){
    return (
        <nav style={{
            display: "flex",
            justifyContent: "flexStart",
            backgroundColor: "#FFFFFF"
        }}>
            <NavLink setWindows={setWindows} name="Home"/>
            <NavLink setWindows={setWindows} name="Resume"/>
            <NavLink setWindows={setWindows} name="About"/>
        </nav>
    )
}

export default Navigation;